import { Component, ElementRef, inject, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { IPopup } from "../../viewer-components/interfaces/i-popup";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  selector: "point-info-popup",
  templateUrl: "./point-info-popup.component.html",
  styleUrls: ["./point-info-popup.component.scss"],
  standalone: false,
})
export class PointInfoPopupComponent implements OnInit, OnDestroy {
  viewerService = inject(VIEWER_SERVICE);

  subscriptions: Subscription[] = [];

  @ViewChild("copiedToolTip", { static: true }) copiedTooltipRef: ElementRef;

  elevation: any = "N/A";

  elevationUnit: string = "";

  location: number[];

  lat: string;

  lng: string;

  type: string;

  epsg: string;

  featuresData: any = null;

  coordinates: number[];

  featureId: string;

  relativePoint = false;

  constructor(
    public dialog: MatDialog,
    public ngZone: NgZone,
  ) {}

  ngOnInit() {
    this.getPointInfoPopup(this.coordinates);
    this.subscriptions.push(
      this.viewerService.updatePointInfoPopup$.subscribe((infoPopup: IPopup) => {
        if (infoPopup && this.featureId === infoPopup.featuresData.getId()) {
          const previousLocation = [Number(this.lng), Number(this.lat)];
          this.loadComponent(infoPopup);

          if (this.hasLocationChanged(previousLocation)) {
            this.viewerService.movePointInfoPopup(infoPopup.coordinates, infoPopup.epsg, this.featureId);
          }
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  loadComponent(info: IPopup): void {
    this.featuresData = info.featuresData;
    this.type = info.type;
    this.epsg = info.epsg;
    this.featureId = this.featuresData.id ? this.featuresData.id : this.featuresData.getId();
    const measurement = this.featuresData.properties
      ? this.featuresData.properties.measurement
      : this.featuresData.getProperties().measurement;

    if (measurement?.relativeElevation) {
      this.elevation = measurement.relativeElevation.valuePretty;
      this.relativePoint = true;
    } else {
      this.elevation = measurement?.elevation.valuePretty;
    }

    this.elevationUnit = measurement?.elevation.unit;
    this.location = measurement?.location.value;
    this.lat = this.location[1].toFixed(6);
    this.lng = this.location[0].toFixed(6);
  }

  getLocation(): string {
    return `${this.lat}, ${this.lng}`;
  }

  getElevation(): string {
    return `${this.elevation} ${this.elevationUnit}`;
  }

  setPointInfoPopup(coordinates: number[]) {
    this.coordinates = coordinates;
    this.location = this.coordinates;
  }

  getPointInfoPopup(coordinates: number[]) {
    this.location = coordinates;
    return this.ngZone.run(() => {
      this.setPointInfoPopup(coordinates);
    });
  }

  /**
   * Compares current lat/lng with new infoPopup location
   * @returns boolean true if location changed
   * @param location
   */
  hasLocationChanged(location: number[]): boolean {
    const newLat = location[1].toFixed(6);
    const newLng = location[0].toFixed(6);
    return newLat !== this.lat || newLng !== this.lng;
  }
}
